import {
  Button,
  Center,
  Flex,
  FormControl,
  FormHelperText,
  HStack,
  Heading,
  PinInput,
  PinInputField,
  Stack,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const VerifyOtp = ({
  config,
  onChange,
  handleClick,
  show,
  handleRegister,
  handleGoBack,
  resendTimer,
  setResendTimer,
  sendOtpAndRegister,
  errors,
  setErrors,
}) => {
  const [otpError, setOtpErr] = useState("");
  const [resendOtp, setResendOtp] = useState(false);
  const [resent, setResent] = useState(false);
  const [otp, setOtp] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleResendOtp = async () => {
    if (!resent) {
      await resendOtp()
        .then((res) => {
          console.log(res);
          toast({
            title: "Resent Otp Success",
            description: `Otp sent on your: ${config.phone} !`,
            status: "success",
            duration: 2000,
            isClosable: true,
          });
          setResent(true);
        })
        .catch((err) => {
          toast({
            title: "Resent Otp Failure",
            description: err.error ?? "Internal Server Error",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
          console.log(err);
        });
    }
  };

  const verifyStore = async (data) => {
    if (data?.otp?.length === 4) {
      await API("/auth/verify-otp", "POST", data)
        .then((res) => {
          console.log(res);
          toast({
            title: "User Creation Success",
            description: `Otp Verified and  ${config?.name} is registered!`,
            status: "success",
            duration: 2000,
            isClosable: true,
          });
          navigate("/login");
        })
        .catch((err) => {
          toast({
            title: "Otp Verification Failed",
            description: err?.error ?? "Internal Server Error!",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
          setOtpErr(err?.error ?? "Invalid Otp Code!");
          console.log(err);
        });
    } else {
      setOtpErr("Requires a four digit otp!");
    }
  };

  const checkOtp = async (data) => {
    setOtp(data);
    await verifyStore({ email: config?.email, otp: data });
  };

  useEffect(() => {
    resendTimer > 0
      ? setTimeout(() => setResendTimer(resendTimer - 1), 1000)
      : setResendOtp(true);
  }, [resendTimer]);

  return (
    <>
      <Flex
        minH={"100vh"}
        align={"center"}
        justify={"center"}
        bg={useColorModeValue("gray.50", "gray.800")}
      >
        <Stack
          spacing={4}
          w={"full"}
          maxW={"sm"}
          bg={useColorModeValue("white", "gray.700")}
          rounded={"xl"}
          boxShadow={"lg"}
          p={6}
          my={10}
        >
          <Center>
            <Heading lineHeight={1.1} fontSize={{ base: "2xl", md: "3xl" }}>
              Verify your Phone
            </Heading>
          </Center>
          <Center
            fontSize={{ base: "sm", sm: "md" }}
            color={useColorModeValue("gray.800", "gray.400")}
          >
            We have sent code to your phone
          </Center>
          <Center
            fontSize={{ base: "sm", sm: "md" }}
            fontWeight="bold"
            color={useColorModeValue("gray.800", "gray.400")}
          >
            {config?.phone}
          </Center>
          <FormControl>
            <Center>
              <HStack>
                <PinInput
                  autoFocus
                  focusBorderColor="green"
                  onComplete={(e) => checkOtp(e)}
                  onChange={() => {
                    setOtpErr("");
                  }}
                  errorBorderColor={"red"}
                  isInvalid={otpError}
                  otp={true}
                >
                  <PinInputField type="number" errorBorderColor={"red"} />
                  <PinInputField type="number" errorBorderColor={"red"} />
                  <PinInputField type="number" errorBorderColor={"red"} />
                  <PinInputField type="number" errorBorderColor={"red"} />
                </PinInput>
              </HStack>
            </Center>
            {resent ? (
              "Otp resent!"
            ) : (
              <>
                {resendOtp ? (
                  <>
                    <p
                      style={{
                        color: "blue",
                        pointerEvents: "all",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleResendOtp();
                      }}
                    >
                      Resend Otp
                    </p>
                  </>
                ) : (
                  <>Resend Otp in {resendTimer} secs</>
                )}
              </>
            )}
            {otpError ? (
              <>
                <FormHelperText color="red">{otpError} </FormHelperText>
              </>
            ) : (
              ""
            )}
          </FormControl>
          <Stack spacing={6}>
            <Button
              bg={"black"}
              color={"white"}
              _hover={{
                bg: "gray.600",
                boxShadow: "lg",
              }}
              onClick={() => verifyStore({ otp, email: config.email })}
            >
              Verify
            </Button>
            <Button
              bg={"grey.500"}
              color={"black"}
              _hover={{
                bg: "white.500",
              }}
              onClick={() => {
                handleGoBack();
              }}
            >
              Go Back
            </Button>
          </Stack>
        </Stack>
      </Flex>
    </>
  );
};

export default VerifyOtp;
